import { useEffect } from 'react';

import { useSearchParams } from 'react-router-dom';

import { useAuthentication } from '@zenbusiness/application-commons-authentication';
import useEnv from '@zenbusiness/application-commons-env';

import { callback } from '#client/constants/routes';

const Login = () => {
  const { OIDC_LOGIN_ENABLED } = useEnv('root-first');
  const { login } = useAuthentication();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Redirect to our custom callback page first, so that we can track analytics for user login.
    // This callback page will parse the query param to redirect to the correct dashboard page afterward.
    // If OIDC is enabled, we pass the custom callback page, with the following page in the query params.
    // Otherwise, we just pass the page to navigate to after callback.
    let finalRedirectUrl = '';
    if (OIDC_LOGIN_ENABLED) {
      finalRedirectUrl = window.location.origin + callback;
      const redirectTo = searchParams.get('redirectTo');
      if (redirectTo) {
        const queryParams = new URLSearchParams();
        queryParams.append('redirectTo', redirectTo);
        finalRedirectUrl = `${finalRedirectUrl}?${queryParams.toString()}`;
      }
    } else {
      finalRedirectUrl = searchParams.get('redirectTo');
    }

    // Support force-MFA
    let forceMfa = false;
    let idempotencyKey = '';
    if (searchParams.get('forceMfa') === 'true') {
      forceMfa = true;
      idempotencyKey = searchParams.get('idempotencyKey');
    }

    login(finalRedirectUrl, forceMfa, idempotencyKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default Login;
